export default __webpack_public_path__ + "static/media/gitmandetect.a30eb526.jpg";